export default {
  af: 'Afrikaans',
  'af-ZA': 'Afrikaans',
  ar: 'Arabic',
  'ar-AE': 'Arabic',
  'ar-BH': 'Arabic',
  'ar-DZ': 'Arabic',
  'ar-EG': 'Arabic',
  'ar-IQ': 'Arabic',
  'ar-JO': 'Arabic',
  'ar-KW': 'Arabic',
  'ar-LB': 'Arabic',
  'ar-LY': 'Arabic',
  'ar-MA': 'Arabic',
  'ar-OM': 'Arabic',
  'ar-QA': 'Arabic',
  'ar-SA': 'Arabic',
  'ar-SY': 'Arabic',
  'ar-TN': 'Arabic',
  'ar-YE': 'Arabic',
  az: 'English',
  'az-AZ': 'English',
  'az-Cyrl-AZ': 'English',
  be: 'English',
  'be-BY': 'English',
  bg: 'English',
  'bg-BG': 'English',
  'bs-BA': 'Bosnian',
  ca: 'Catalan',
  'ca-ES': 'Catalan',
  cs: 'Czech',
  'cs-CZ': 'Czech',
  cy: 'Welsh',
  'cy-GB': 'Welsh',
  da: 'Danish',
  'da-DK': 'Danish',
  de: 'German',
  'de-AT': 'German',
  'de-CH': 'German',
  'de-DE': 'German',
  'de-LI': 'German',
  'de-LU': 'German',
  dv: 'English',
  'dv-MV': 'English',
  el: 'Greek',
  'el-GR': 'Greek',
  en: 'English',
  'en-AU': 'English',
  'en-BZ': 'English',
  'en-CA': 'English',
  'en-CB': 'English',
  'en-GB': 'English',
  'en-IE': 'English',
  'en-JM': 'English',
  'en-NZ': 'English',
  'en-PH': 'English',
  'en-TT': 'English',
  'en-US': 'English',
  'en-ZA': 'English',
  'en-ZW': 'English',
  eo: 'English',
  es: 'Spanish',
  'es-AR': 'Spanish',
  'es-BO': 'Spanish',
  'es-CL': 'Spanish',
  'es-CO': 'Spanish',
  'es-CR': 'Spanish',
  'es-DO': 'Spanish',
  'es-EC': 'Spanish',
  'es-ES': 'Spanish',
  'es-GT': 'Spanish',
  'es-HN': 'Spanish',
  'es-MX': 'Spanish (Mexico)',
  'es-NI': 'Spanish',
  'es-PA': 'Spanish',
  'es-PE': 'Spanish',
  'es-PR': 'Spanish',
  'es-PY': 'Spanish',
  'es-SV': 'Spanish',
  'es-UY': 'Spanish',
  'es-VE': 'Spanish',
  et: 'Estonian',
  'et-EE': 'Estonian',
  eu: 'English',
  'eu-ES': 'English',
  fa: 'Farsi (Persian)',
  'fa-IR': 'Farsi (Persian)',
  fi: 'Finnish',
  'fi-FI': 'Finnish',
  fo: 'English',
  'fo-FO': 'English',
  fr: 'French',
  'fr-BE': 'French',
  'fr-CA': 'French (Canada)',
  'fr-CH': 'French',
  'fr-FR': 'French',
  'fr-LU': 'French',
  'fr-MC': 'French',
  gl: 'English',
  'gl-ES': 'English',
  gu: 'Gujarati',
  'gu-IN': 'Gujarati',
  he: 'Hebrew',
  'he-IL': 'Hebrew',
  hi: 'Hindi',
  'hi-IN': 'Hindi',
  hr: 'Croatian',
  'hr-BA': 'Croatian',
  'hr-HR': 'Croatian',
  hu: 'Hungarian',
  'hu-HU': 'Hungarian',
  hy: 'Armenian',
  'hy-AM': 'Armenian',
  id: 'Indonesian',
  'id-ID': 'Indonesian',
  is: 'Icelandic',
  'is-IS': 'Icelandic',
  it: 'Italian',
  'it-CH': 'Italian',
  'it-IT': 'Italian',
  ja: 'Japanese',
  'ja-JP': 'Japanese',
  ka: 'Georgian',
  'ka-GE': 'Georgian',
  kk: 'Kazakh',
  'kk-KZ': 'Kazakh',
  kn: 'Kannada',
  'kn-IN': 'Kannada',
  ko: 'Korean',
  'ko-KR': 'Korean',
  kok: 'English',
  'kok-IN': 'English',
  ky: 'Kyrgyz',
  'ky-KG': 'Kyrgyz',
  lt: 'Lithuanian',
  'lt-LT': 'Lithuanian',
  lv: 'Latvian',
  'lv-LV': 'Latvian',
  mi: 'Maori',
  'mi-NZ': 'Maori',
  mk: 'Macedonian',
  'mk-MK': 'Macedonian',
  mn: 'Mongolian',
  'mn-MN': 'Mongolian',
  mr: 'Marathi',
  'mr-IN': 'Marathi',
  ms: 'Malay',
  'ms-BN': 'Malay',
  'ms-MY': 'Malay',
  mt: 'Maltese',
  'mt-MT': 'Maltese',
  nb: 'Norwegian (Bokmål)',
  'nb-NO': 'Norwegian (Bokmål)',
  nl: 'Dutch',
  'nl-BE': 'Dutch',
  'nl-NL': 'Dutch',
  'nn-NO': 'English',
  ns: 'English',
  'ns-ZA': 'English',
  pa: 'Punjabi',
  'pa-IN': 'Punjabi',
  pl: 'Polish',
  'pl-PL': 'Polish',
  ps: 'Pashto',
  'ps-AR': 'Pashto',
  pt: 'Portuguese (Brazil)',
  'pt-BR': 'Portuguese (Brazil)',
  'pt-PT': 'Portuguese (Portugal)',
  qu: 'English',
  'qu-BO': 'English',
  'qu-EC': 'English',
  'qu-PE': 'English',
  ro: 'Romanian',
  'ro-RO': 'Romanian',
  ru: 'Russian',
  'ru-RU': 'Russian',
  sa: 'English',
  'sa-IN': 'English',
  se: 'English',
  'se-FI': 'English',
  'se-NO': 'English',
  'se-SE': 'English',
  sk: 'Slovak',
  'sk-SK': 'Slovak',
  sl: 'Slovenian',
  'sl-SI': 'Slovenian',
  sq: 'Albanian',
  'sq-AL': 'Albanian',
  'sr-BA': 'Serbian',
  'sr-Cyrl-BA': 'Serbian',
  'sr-SP': 'Serbian',
  'sr-Cyrl-SP': 'Serbian',
  sv: 'Swedish',
  'sv-FI': 'Swedish',
  'sv-SE': 'Swedish',
  sw: 'Swahili',
  'sw-KE': 'Swahili',
  syr: 'English',
  'syr-SY': 'English',
  ta: 'Tamil',
  'ta-IN': 'Tamil',
  te: 'Telugu',
  'te-IN': 'Telugu',
  th: 'Thai',
  'th-TH': 'Thai',
  tl: 'Filipino, Tagalog',
  'tl-PH': 'Filipino, Tagalog',
  tn: 'Tswana',
  'tn-ZA': 'Tswana',
  tr: 'Turkish',
  'tr-TR': 'Turkish',
  tt: 'English',
  'tt-RU': 'English',
  ts: 'English',
  uk: 'Ukrainian',
  'uk-UA': 'Ukrainian',
  ur: 'Urdu',
  'ur-PK': 'Urdu',
  uz: 'Uzbek',
  'uz-UZ': 'Uzbek',
  'uz-Cyrl-UZ': 'Uzbek',
  vi: 'Vietnamese',
  'vi-VN': 'Vietnamese',
  xh: 'English',
  'xh-ZA': 'English',
  zh: 'Chinese',
  'zh-CN': 'Chinese (Simplified)',
  'zh-HK': 'Chinese (Simplified)',
  'zh-MO': 'Chinese (Simplified)',
  'zh-SG': 'Chinese (Simplified)',
  'zh-TW': 'Chinese (Traditional)',
  zu: 'English',
  'zu-ZA': 'English',
};
